import React, { useEffect, useState } from 'react'
import { RENEW_PAGE_ADJUST_CAR_VALUE, RENEW_PAGE_CHOOSE_DOWNGRADE_PLAN, RENEW_PAGE_CPR_NUMBER, RENEW_PAGE_CPR_PLATE_NUMBER, RENEW_PAGE_ENHANCE_YOUR_COVERAGE, RENEW_PAGE_REVIEW_AND_CONFIRM, RENEW_PAGE_REVIEW_YOUR_POLICY, RENEW_PAGE_SELECT_POLICY, RENEW_PAGE_VERIFY_OTP, CHANGE_PLAN_UPLOAD_PHOTOS_OF_CAR } from './data';
import AdjustCarValuePage from './adjustCarValuePage/adjustCarValuePage';
import ChooseDowngradePlanPage from './chooseDowngradePlanPage/chooseDowngradePlanPage';
import CprNumberPage from './cprNumberPage/cprNumberPage';
import EnhanceYourCoveragePage from './enhanceYourCoveragePage/enhanceYourCoveragePage';
import ReviewAndConfirmPage from './reviewAndConfirmPage/reviewAndConfirmPage';
import ReviewYourPolicyPage from './reviewYourPolicyPage/reviewYourPolicyPage';
import VerifyOtpPage from './verifyOtpPage/verifyOtpPage';
import SelectPoliciesPage from './selectPoliciesPage/selectPoliciesPage';
import Modal from '../../../components/common/modal/modal';
import Header from '../../../components/common/Header/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setRenewalFlowType } from '../../../redux/features/motorInsuranceRenewFlowSlice';
import useRenewalFlow from '../../../hooks/useRenewalFlow';
import CprPlateNumberPage from './cprNumberPage/cprPlateNumberPage';
import UploadsMainPage from '../changePlanMotorPolicy/uploadsMainPage/uploadsMainPage';

const RenewalMotorPolicy = () => {
    const {currentStep} = useRenewalFlow()
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(true);

    // When arriving from /renew, location.state.motorFlow carries the intended
    // flow type and step index. Apply it on mount so a stale Redux flow
    // (e.g. reset by clearRenewalFlow on dashboard/hub mount) cannot land us
    // on the wrong page.
    useEffect(() => {
      const motorFlow = location.state?.motorFlow;
      if (motorFlow?.type) {
        dispatch(setRenewalFlowType(motorFlow));
        // Clear it so a later page navigation/back doesn't re-apply it
        navigate(location.pathname + (location.search || ''), { replace: true, state: {} });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCloseModal = () => {
        setShowModal(false);
        navigate("/renew");
    };

    const PageRenderer = () => {
        switch (currentStep?.name) {
            case RENEW_PAGE_CPR_NUMBER:
                return <CprNumberPage />
            case RENEW_PAGE_CPR_PLATE_NUMBER:
                return <CprPlateNumberPage />
            case RENEW_PAGE_ADJUST_CAR_VALUE:
                return <AdjustCarValuePage />
            case RENEW_PAGE_CHOOSE_DOWNGRADE_PLAN:
                return <ChooseDowngradePlanPage />
            case RENEW_PAGE_ENHANCE_YOUR_COVERAGE:
                return <EnhanceYourCoveragePage />
            case RENEW_PAGE_REVIEW_AND_CONFIRM:
                return <ReviewAndConfirmPage />
            case RENEW_PAGE_REVIEW_YOUR_POLICY:
                return <ReviewYourPolicyPage />;
            case RENEW_PAGE_SELECT_POLICY:
                return <SelectPoliciesPage />;
            case RENEW_PAGE_VERIFY_OTP:
                return <VerifyOtpPage />;
            case CHANGE_PLAN_UPLOAD_PHOTOS_OF_CAR:
                return <UploadsMainPage passedFrom={"MotorRenewal"} />;
            default:
                return null
        }
    };
    return (
        <Modal show={showModal}>
            <div className="flex flex-col h-full max767:h-screen">
                <div className="flex-shrink-0 sticky top-0 z-50 bg-white">
                    <Header isPopup onCloseModal={handleCloseModal} />
                </div>
                <div id="renew-motor-back-portal" />
                <div className="mainCarDetailsModal relative pt-5 pb-[5%] flex-1 max767:w-full max767:overflow-y-auto max767:pb-[120px] ipad:pt-[10%] ipad:h-auto ipad:overflow-y-auto max767:pt-[88px]">
                    {PageRenderer()}
                </div>
            </div>
        </Modal>
    )
}

export default RenewalMotorPolicy
